<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Apply Canteen Facility</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="4" md="4">
                        <p><v-icon color="error">*</v-icon><b>Child</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="child" :items="child_list" item-text="learner" item-value="id" label="Child" outlined persistent-hint hint="Please Select Child" />
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                        <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
                    </v-col>
                    <v-col col="12" sm="2" md="2" class="pt-6 mt-6" v-if="this.ay && this.child">
                        <v-btn color="warning" @click="fetchData()">Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <br />
            <v-card class="box" v-if="show_child_details_card">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Child Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="2">
                        <p><b>PRN</b></p>
                        <strong>{{child_details[0].registration_number}}</strong>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <p><b>Student Name</b></p>
                        <strong>{{child_details[0].learner}}</strong>
                    </v-col>
                    <v-col cols="12" sm="1">
                        <p><b>Standard</b></p>
                        <strong>{{child_details[0].standard}}</strong>
                    </v-col>
                    <v-col cols="12" sm="1">
                        <p><b>Menu Card</b></p>
                       <template v-if="this.menu_card!=null">
                        <a class="p-2" :href="aws_path + this.menu_card" target="blank">
                            <v-icon color="black">mdi-eye</v-icon>
                    </a>
              </template>
              <template v-else>
                 <span>--</span>
              </template>
                    </v-col>
                </v-row>
            </v-card>
            <v-row justify="center" dense v-if="show_child_details_card">
                <v-col cols="12" sm="1" md="1"></v-col>
                <v-col col="12" sm="4" md="4" v-if="learner_canteen_fees_list.length < 1">
                    <v-btn color="warning" @click="applyCanteen()">Apply For Payment Method</v-btn>
                </v-col>
            </v-row>

            <v-card class="box" v-if="apply_payment_card">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Select Payment Method</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <!-- <v-card class="box"> -->
                <v-row justify="center" dense>
                    <v-col cols="12" sm="4" md="4">
                        <p><b>Total Fees Applicable In Rs.</b></p>
                        <v-text-field outlined dense type="text" v-model="canteenFees" readonly color="grey"></v-text-field>
                    </v-col>
                </v-row>
                <v-row justify="center" dense v-if="!this.canteen_fee_sync">
                    <span v-for="(inst, index) in canteen_installments" :key="index">
                        <input type="radio" class="radiospace" v-model="canteen_installment" v-bind:value="inst" @change="setName(inst.id)" />
                        {{ inst.name }}
                    </span>
                </v-row>
                 <v-row v-else justify="center" dense>
                    <v-btn small color="warning" @click="SaveCanteenInstallmentNew()"
                        >Apply Canteen</v-btn
                    >
                    </v-row>
                <v-row justify="center" dense v-if="show_fees">
                    <p><b>Installment Fees In Rs.</b></p>
                    {{ fees_applicable }}
                </v-row>
                <v-row justify="center" dense v-if="show_fees">
                    <v-btn small color="warning" @click="SaveCanteenInstallment()">Save</v-btn>
                </v-row>
                <!-- </v-card> -->
            </v-card>

             <span v-if="canteen_fee_sync != true">
            <v-card class="box" v-if="learner_canteen_installments!=''">
                <v-data-table :headers="headers" dense class="elevation-1" :items="learner_canteen_installments">
                    <template v-slot:top>
                        <v-toolbar flat dense class="toolbar">
                            <v-toolbar-title>Canteen-Installment Details</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template v-slot:[`item.is_applied`]="{ item }">
                        <span v-if="item.is_applied">
                            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                        </span>
                    </template>
                    <template v-slot:[`item.delete_installment`]="{ item }">
                        <span v-if="item.can_delete_installment">
                            <v-avatar size="35">
                             <v-icon
                                class="mr-4 v-icon-size"
                                color="red"
                                @click="deleteInstallment(item)"
                                >mdi-trash-can</v-icon
                                >
                            </v-avatar>
                        </span>
                         <span v-else>
                            --
                         </span>
                    </template>
                    <template v-slot:[`item.is_approved`]="{ item }">
                        <span v-if="item.is_approved">
                            <!-- <span v-if="item.ispaid == true"> -->
                            <span v-if="item.amount_to_pay <= 0">
                                <strong>Already Paid</strong>
                            </span>
                            <span v-else>
                                <form :action="url" @submit="payment" name="paytmform" method="POST">
                                    <input type="hidden" :value="item.orgid" name="orgid" />
                                    <input type="hidden" :value="item.tenantid" name="tenantid" />
                                    <input type="hidden" :value="item.uid" name="uid" />
                                    <input type="hidden" :value="item.learner_id" name="studid" />
                                    <!-- <input type="hidden" :value="item.amount" name="fee_amount" /> -->
                                    <input type="hidden" :value="item.amount_to_pay" name="fee_amount" />
                                    <input type="hidden" :value="item.ay" name="ay" />
                                    <input type="hidden" :value="'Canteen - ' +item.name" name="purpose" />
                                    <input type="hidden" :value="item.learner_canteen_fees_installment_id" name="learner_canteen_fees_installment_id" />
                                    <!-- //Code Changed By mayur -->
                                    <!-- <input type="hidden" :value="item.id" name="json_pre_trans_data"/> //Code Changed By mayur -->
                                    <input type="hidden" :value="item.learner_canteen_fees_installment_id" name="json_pre_trans_data" />
                                    <input type="hidden" :value="item.hash_val" name="hash_val" />
                                    <v-btn small color="warning" type="submit" :loading="loader">Pay</v-btn>
                                </form>
                            </span>
                        </span>
                        <span v-else> -- </span>
                    </template>
                    <template v-slot:[`item.print`]="{ item }">
                        <span v-for="item in item.receipt_no" :key="item">
                            <v-tooltip top color="warning">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mt-1 mb-1" rounded outlined small color="warning" v-bind="attrs" v-on="on" @click="print(item, item.ay)"> <v-icon color="warning">mdi-printer</v-icon>{{ item }}</v-btn>
                                </template>
                                <span> Print Fee Receipt!!! </span>
                            </v-tooltip>
                        </span>
                    </template>
                </v-data-table>
            </v-card>
             </span>

               <span v-else>
            <v-card class="box" v-if="learner_canteen_installments!=''">
                <v-data-table :headers="headers_2" dense class="elevation-1" :items="learner_canteen_installments">
                    <template v-slot:top>
                        <v-toolbar flat dense class="toolbar">
                            <v-toolbar-title>Canteen-Installment Details</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template v-slot:[`item.canteenapprovalstatus`]="{ item }">
                        <span v-if="item.is_canteen_sync">
                            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                        </span>
                    </template>
                           <template v-slot:[`item.cancel_request`]="{ item }">
            <span v-if="item.raise_cancel_request ==true && item.request_for_calcellation == false && item.is_canteen_sync==true && item.iscancelled == false " >
                <v-btn small color="warning" @click="requestCanteenInstallmentCancel(item)"
                   >Request Cancel</v-btn
          >
            </span>
           <span v-else-if="item.raise_cancel_request ==false">
             Fees Paid...Cannot Cancel
            </span>
           <span v-else-if="item.iscancelled ==true">
             Already Cancelled
            </span>
                <span v-else-if="item.is_canteen_sync ==false">
                         Fees Not Synced...Cannot Cancel
            </span>
             <span v-else-if="item.request_for_calcellation ==true">
                  Already Requested
            </span>
              <span v-else>
              <v-icon class="mr-2 v-icon-size" color="error"
                >mdi-close-circle-outline</v-icon
              >
              <!-- Cannot Cancel -->
            </span>
          </template>
                </v-data-table>
            </v-card>
             </span>

            <!-- {{child_details}}
      {{canteenFees}} -->
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            canteen_fee_sync:false,
            loader: false,
            radios: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            menu_card:null,

            headers: [
                { text: "Sr No", value: "srno" },
                { text: "Installment", value: "name" },
                { text: "Amount", value: "amount" },
                //   { text: "Paid Till Now", value: "paid_till_now" },
                { text: "Amount Paid Till Now", value: "paid_till_now" },
                { text: "Amount To Pay", value: "amount_to_pay" },
                { text: "Approval Status", value: "canteenapprovalstatus" },
                { text: "Payment", value: "is_approved" },
                { text: "Print Receipt", value: "print" },
                { text: "Delete Installment", value: "delete_installment" },
            ],
             headers_2: [
                { text: "Sr No", value: "srno" },
                { text: "Installment", value: "name" },
                { text: "Amount", value: "amount" },
                // { text: "Amount", value: "sync_amount" },
                //   { text: "Paid Till Now", value: "paid_till_now" },
                // { text: "Amount Paid Till Now", value: "paid_till_now" },
                // { text: "Amount To Pay", value: "amount_to_pay" },
                { text: "Approval Status", value: "canteenapprovalstatus" },
                // { text: "Payment", value: "is_approved" },
                // { text: "Print Receipt", value: "print" },
                // { text: "Delete Installment", value: "delete_installment" },
                 { text: "Raise Cancel Request", value: "cancel_request" },
            ],
            ay_list: [],
            ay: "",
            child_list: [],
            child: "",
            show_fees: false,
            url: "",
            child_details: [],
            canteenFees: "",
            canteenFees_id: "",
            show_child_details_card: false,
            learner_canteen_fees_list: [],
            apply_payment_card: false,
            canteen_installments: [],
            canteen_installment: "",
            show_fees: false,
            fees_applicable: "",
            learner_canteen_installments: [],
            aws_path:null,
            menu_card:null,
        }),
        created() {
            this.url = process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm_canteen";
            this.aws_path = localStorage.getItem("awspath");
        },
        methods: {
            requestCanteenInstallmentCancel(item) {
            if (!confirm("Are You Sure You Want To Cancel...?")) return;
            const data = {
                feesinstallmant_id: item.feesinstallmant_id,
            };
            this.overlay = true;
            axios
                .post("/Canteen/requestCanteenInstallmentCancel", data)
                .then((res) => {
                if (res.data.flag == "YES") {
                    this.showSnackbar("green", "Request Sent...");
                } else if (res.data.flag == "No") {
                    this.showSnackbar("red", res.data.snackbar);
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
                })
                .catch((error) => {
                this.onerror(error);

                this.overlay = false;
                })
                .finally(() => {
                this.overlay = false;
                this.fetchData();
                });
            },
            deleteInstallment(canteen_installment){
                  if (!confirm("Are You Sure You Want To Delete Installment...?")) return;
                const data = {
                    canteen_installment: canteen_installment.learner_canteen_fees_installment_id,
                };
                this.overlay = true;
                axios
                    .post("/Canteen/deleteInstallment", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                          //  this.transport_installments = res.data.transport_installments;
                            this.learner_canteen_installments = res.data.learner_canteen_installments;
                            this.showSnackbar("green", "Deleted Successfully...");
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.resetData();
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                       // this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            SaveCanteenInstallmentNew() {
                if (!confirm("Are You Sure You Want To Apply...?")) return;
                const data = {
                    academicYear: this.ay,
                    learner: this.child_details[0].lid,
                    canteenFees_id: this.canteenFees_id,
                };
                this.overlay = true;
                axios
                    .post("/Canteen/SaveLearnerCanteenInstallmentNew", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                          //  this.transport_installments = res.data.transport_installments;
                            this.learner_canteen_installments = res.data.learner_canteen_installments;
                            this.showSnackbar("green", "Applied Successfully...");
                            this.apply_payment_card = false;
                            this.resetData();
                        } else if (res.data.flag == "No") {
                            this.apply_payment_card = false;
                            this.showSnackbar("red", res.data.snackbar);
                            this.resetData();
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.resetData();
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.resetData();
                    });
            },
             SaveCanteenInstallment() {
                if (!confirm("Are You Sure You Want To Apply...?")) return;
                const data = {
                    academicYear: this.ay,
                    learner: this.child_details[0].lid,
                    canteen_installment: this.canteen_installment.id,
                    fees_applicable: this.fees_applicable,
                    canteenFees_id: this.canteenFees_id,
                };
                this.overlay = true;
                axios
                    .post("/Canteen/SaveLearnerCanteenInstallment", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                          //  this.transport_installments = res.data.transport_installments;
                            this.learner_canteen_installments = res.data.learner_canteen_installments;
                            this.showSnackbar("green", "Applied Successfully...");
                            this.apply_payment_card = false;
                            this.resetData();
                        } else if (res.data.flag == "No") {
                            this.apply_payment_card = false;
                            this.showSnackbar("red", res.data.snackbar);
                            this.resetData();
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.resetData();
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.resetData();
                    });
            },
            resetData() {
                this.show_fees = false;
                this.canteen_installment = "";
                this.fees_applicable = "";
            },
            print(receipt_no, ay) {
                this.receipt_no = receipt_no;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                let routeData = this.$router.resolve({ name: "canteen-receipt" });
                window.open(routeData.href, "_blank");
            },
            payment() {
                var formData = new FormData(paytmform);
                console.log("formData");
                console.log(formData);
                this.loader = false;
            },
          
            setName(installment_name) {
                const data = {
                    installment: installment_name,
                    canteenFees_id: this.canteenFees_id,
                };
                this.overlay = true;
                axios
                    .post("/Canteen/getInstallmentAmount", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.fees_applicable = res.data.final_amount;
                            this.show_fees = true;
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            applyPaymentMethod(learner_transport_fees_id) {
                (this.fees_applicable = ""), (this.fees_applicable_origional = ""), (this.transport_installment = []), (this.show_fees = false), (this.all_transport_installments = []); //chamged by mayur
                this.learner_transport_fees_amount_id = learner_transport_fees_id;
                const data = {
                    learner_transport_fees_id: learner_transport_fees_id,
                };
                this.overlay = true;
                axios
                    .post("/ParentTransport/applyPaymentMethod", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.fees_details.totalfees = res.data.totalfees;
                            this.fees_details.paid_till_now = res.data.paid_till_now;
                            this.fees_details.routestop = res.data.routestop;
                            this.fees_details.route = res.data.route;
                            this.fees_details.distanceslab = res.data.distanceslab;
                            this.all_transport_installments = res.data.transport_installments;
                            this.fees_applicable = res.data.totalfees;
                            (this.fees_applicable_origional = res.data.totalfees), (this.learner_transport_fees_id = res.data.learner_transport_fees_id);
                            // this.learner_transport_fees_installment_details =res.data.learner_transport_fees_installment_details;
                            this.apply_payment_card = true;
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            applyCanteen() {
                this.apply_payment_card = true;
            },
            fetchData() {
                this.resetData();
                const data = {
                    ay: this.ay,
                    child: this.child,
                };
                this.overlay = true;
                axios
                    .post("/Canteen/getChildAcademicDetails", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.child_details = res.data.child_details;
                            this.canteenFees = res.data.canteenFees;
                            this.canteenFees_id = res.data.canteenFees_id;
                            this.canteen_installments = res.data.canteen_installments;
                            this.learner_canteen_installments = res.data.learner_canteen_installments;
                            this.menu_card = res.data.menu_card;
                            this.show_child_details_card = true;
                            this.canteen_fee_sync=res.data.canteen_fee_sync
                        }else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } 
                        else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                      //  this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            onLoad() {
                axios
                    .post("ParentTransport/applyTransportFacility")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
                            this.child_list = res.data.learner_list;
                            this.overlay = false;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
       
        mounted() {
            this.onLoad();
        },
        watch: {},
    };
</script>
<style scoped>
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    sub-row {
        border: 2px solid #424093;
        margin: 1rem;
        border-radius: 5px;
    }

    i {
        font-size: 20px !important;
    }

    .v-card__title {
        border: 1px solid #80808040;
        font-weight: bold;
        background-color: #424093;
        color: white;
        text-align: center;
        /* margin-top: 1.5rem; */
    }
    .card-border {
        border: 2px solid darkblue;
        border-radius: 10px;
        /* padding: 5px; */
        /* margin: 1rem !important; */
        width: auto;
    }

    .tx-bold {
        font-weight: bold;
        font-size: 14px;
        color: black;
    }

    i {
        font-size: 26px;
        cursor: pointer;
    }

    theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        background-color: #424093 !important;
        color: white !important;
        margin-top: 2.35rem;
        border-radius: 20px;
    }

    /*.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover {
    background-color: orange !important;
    color: black !important;
} */

    @media only screen and (max-width: 600px) {
    }

    .imgs {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: 150px;
        cursor: zoom-in;
    }

    .imgs-preview {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: auto;
    }

    v-simple-table {
        border-collapse: collapse;
        border-spacing: 0;
        width: auto;
        border: 1px solid #ddd;
    }

    th {
        color: white;
        font-weight: bold;
        text-align: center !important;
    }

    td,
    th {
        padding: 6px;
        border: 1px solid #ccc;
        text-align: center;
    }
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }

    @media all and (min-width: 1000px) {
        .padding-metting {
            padding-right: 22px;
        }
    }
    @media (min-width: 320px) and (max-width: 350px) {
        .padding-bot {
            font-size: 11.6px;
        }
    }
    @media (min-width: 1000px) and (max-width: 1050px) {
        .padding-bot {
            font-size: 9.6px;
        }
    }
    .slide {
        color: red;
        font-weight: bold;
        margin-left: 10px;
    }
    .note-list {
        background-color: orange;
    }
</style>
